<template>
  <div class="background-white pt-3 pb-5 section-mobile">
		<v-layout column align-center>
			<v-flex xs6 text-xs-center class="online-mobile">
				Comienza a vender <br> online desde <span class="bold ft-24"> S/500 </span>
			</v-flex>
			<v-flex xs12 mt-4>
				<v-btn
					class="btn-action btn-auto btn-request-app white--text"
					color="orange"
					depressed
					@click="$emit('open-modal-btn')">
					SOLICITA TU APP
				</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
export default {
	name: 'section-mobile',
	props: {
		link: [String],
	},
};
</script>

<style lang="scss" scoped>
.background-white {
	background-color: white;
}

.section-mobile {
	@media (min-width: 1024px) {
		display: none;
	}
}

.online-mobile {
		border-radius: 8px;
  	background-color: rgba(141, 205, 208, 0.45);
		color: #02979b;
		font-family: font(lato-regular);
		font-size: 20px;
		font-weight: 500;
		height: 76px !important;
		padding: 14px 9px;
		width: 232px;
	}

	.sub-title-mobile {
		color: #494949;
		font-family: font('lato-regular');
		font-size: 30px;
		font-weight: 900;
	}
	
	.btn-request-app {
		border-radius: 8px;
		font-family: font('lato-regular');
		font-size: 20px;
		font-weight: 900;
		height: 60px !important;
		width: 271px !important;
	}

	.text-orange {
		color: color(primary-cs);
	}

	.ft-24 {
		font-size: 24px;
	}

	.text-decoration-none {
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-mobile.vue